import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Container, ListGroup, Button, Spinner, Alert } from 'react-bootstrap';
import axios from '../AxiosConfig';

const TagManagement = () => {
  const [tags, setTags] = useState({ My_org_collects: [], collaborativeInterests: [], regions: [], countries: [] });
  const [loadingTags, setLoadingTags] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTags = async () => {
      setLoadingTags(true);
      try {
        const response = await axios.get('/api/admin/manageTags');
        setTags(response.data.tags);
      } catch (err) {
        console.error('Error fetching tags:', err);
        setError("Failed to load tags. Please try again.");
      } finally {
        setLoadingTags(false);
      }
    };

    fetchTags();
  }, []);

  const toggleTagActivity = async (tagId, tagType) => {
    try {
      const response = await axios.post('/api/admin/updateTagActivity', { tag_id: tagId });
      if (response.data.success) {
        setTags((prev) => ({
          ...prev,
          [tagType]: prev[tagType].map((tag) =>
            tag.id === tagId ? { ...tag, isActive: !tag.isActive } : tag
          ),
        }));
      } else {
        console.error('Failed to update tag activity');
      }
    } catch (err) {
      console.error('Error updating tag activity:', err);
    }
  };

  const renderTags = (tags, category) => (
    <ListGroup>
      {tags.length > 0 ? (
        tags.map((tag) => (
          <ListGroup.Item key={tag.id} className="d-flex justify-content-between align-items-center">
            {tag.name}
            <Button
              variant={tag.isActive ? 'success' : 'secondary'}
              onClick={() => toggleTagActivity(tag.id, category)}
            >
              {tag.isActive ? 'Active' : 'Not Active'}
            </Button>
          </ListGroup.Item>
        ))
      ) : (
        <p>No {category.toLowerCase()} tags found.</p>
      )}
    </ListGroup>
  );

  if (loadingTags) return <Spinner animation="border" className="mt-5" />;
  if (error) return <Alert variant="danger" className="mt-5">{error}</Alert>;

  return (
    <Container>
      <Tabs defaultActiveKey="My_org_collects" id="tag-management-tabs" className="mb-3">
        <Tab eventKey="My_org_collects" title="My Org Collects Tags">
          {renderTags(tags.My_org_collects, 'My_org_collects')}
        </Tab>
        <Tab eventKey="collaborativeInterests" title="Collaborative Interests Tags">
          {renderTags(tags.collaborativeInterests, 'collaborativeInterests')}
        </Tab>
        <Tab eventKey="regions" title="Region Tags">
          {renderTags(tags.regions, 'regions')}
        </Tab>
        <Tab eventKey="countries" title="Country Tags">
          {renderTags(tags.countries, 'countries')}
        </Tab>
      </Tabs>
    </Container>
  );
};

export default TagManagement;